import { jwtDecode } from "jwt-decode";

export const jwtVerify = (token) => {
  if (!token) return false;
  try {
    const { exp } = jwtDecode(token);
    return exp > Date.now() / 1000;
  } catch {
    return false;
  }
};
